import { render, staticRenderFns } from "./NoList.vue?vue&type=template&id=8c932fd0&scoped=true&"
import script from "./NoList.vue?vue&type=script&lang=js&"
export * from "./NoList.vue?vue&type=script&lang=js&"
import style0 from "./NoList.vue?vue&type=style&index=0&id=8c932fd0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c932fd0",
  null
  
)

export default component.exports